<template>
  <v-container fluid>
    <bread-crumb :breadcrumb-data="breadcrumbData"></bread-crumb>

    <v-sheet  class="pa-2 my-6" rounded outlined min-height="600">
      <v-sheet class="pa-2">
        <v-row>
          <v-col cols="2" class="font-weight-bold">Signature Name:</v-col>
<!--          <v-col cols="9">{{ signatureName || 'None' }}</v-col>-->
          <v-col cols="9">
            <template v-if="heading">
              <a
                  v-if="signature_type === 'cofigure'"
                  :href="`https://pfocr.wikipathways.org/figures/${signatureName}`"
                  target="_blank"
              >
                {{ signatureName }}
              </a>

              <a
                  v-else-if="mesh_url"
                  :href="mesh_url"
                  target="_blank"
              >
                {{ signatureName }}
              </a>

            </template>
            <span v-else>
                {{ signatureName }}
            </span>
          </v-col>

          <v-spacer></v-spacer>

        </v-row>
        <v-row>
          <v-col cols="2" class="font-weight-bold">Signature Type:</v-col>
          <v-col cols="9">{{ signature_type}}</v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row v-if="heading && signature_type !== 'cogene'">
          <v-col cols="2" class="font-weight-bold">Heading:</v-col>
          <v-col cols="9">
            <template v-if="heading">
              <a
                  v-if="mesh_url"
                  :href="mesh_url"
                  target="_blank"
              >
                {{ heading }}
              </a>
              <span v-else>
      {{ heading }}
    </span>
            </template>
            <span v-else>None</span>
          </v-col>

          <v-spacer></v-spacer>
        </v-row>
        <v-row>
          <v-col cols="2" class="font-weight-bold">Sites Number:</v-col>
          <v-col cols="9">{{ site_number || 'None' }}</v-col>
          <v-spacer></v-spacer>
        </v-row>
        <!-- Description (non-annotation signatures) -->
        <v-row v-if="!useAnnotation">
          <v-col cols="2" class="font-weight-bold">Description:</v-col>
          <v-col cols="9">{{ description || "None" }}</v-col>
        </v-row>

        <template v-else>
          <v-row
              v-for="(label, key) in annotationLabels"
              :key="key"
              v-if="annotation[key]"
          >
            <v-col cols="2" class="font-weight-bold">
              {{ label }}:
            </v-col>
            <v-col cols="9" style="white-space: pre-wrap;">
              {{ annotation[key].trim() }}
            </v-col>
          </v-row>
        </template>




      </v-sheet>

     <v-sheet outlined style="max-height: 800px; overflow-y: auto;" class="my-4">
       <v-data-table
           :headers="headers"
           :items="results"
           :items-per-page="10"
           class="elevation-2 "
       >
         <template v-slot:no-data>
           <v-alert type="info" text>No data available</v-alert>
         </template>

         <template v-slot:item.internal_id="{ item }">
           <router-link :to="`/single-search/${item.internal_id}?ptm_type=phosphorylation`" target="_blank">
             {{ item.internal_id }}
           </router-link>
         </template>
         <!-- Publication -->
         <template v-slot:item.publication="{ item }">
           <div>
             <template v-if="item.pmid && item.pmid.length">
      <span
          v-for="(m, idx) in getVisible(item.pmid, item.showAllPmid)"
          :key="'pmid_' + m"
          class="mr-2"
      >
        <a
            :href="`https://pubmed.ncbi.nlm.nih.gov/${m}/`"
            target="_blank"
        >
          {{ Math.floor(m) }}
        </a>
      </span>
               <v-btn
                   v-if="item.pmid.length > limit"
                   class="my-2"
                   outlined
                   x-small
                   @click="item.showAllPmid = !item.showAllPmid"
               >
                 {{ item.showAllPmid ? "Show Less" : "Show More" }}
               </v-btn>
             </template>

             <template v-else-if="item.pmc && item.pmc.length">
      <span
          v-for="(p, idx) in getVisible(item.pmc, item.showAllPmc)"
          :key="'pmc_' + p"
          class="mr-2"
      >
        <a
            :href="`https://pmc.ncbi.nlm.nih.gov/articles/${p.toLowerCase()}/`"
            target="_blank"
        >
          {{ p }}
        </a>
      </span>
               <v-btn
                   v-if="item.pmc.length > limit"
                   class="my-2"
                   outlined
                   x-small
                   @click="item.showAllPmc = !item.showAllPmc"
               >
                 {{ item.showAllPmc ? "Show Less" : "Show More" }}
               </v-btn>
             </template>

             <span v-else>-</span>
           </div>
         </template>

         <template v-slot:item.pfocr="{ item }">
           <div v-if="item.pfocr && item.pfocr.length">
             <div
                 v-for="(pf, idx) in getVisible(item.pfocr, item.showAllPfocr)"
                 :key="pf.key"
             >
               <a :href="pf.value" target="_blank">{{ pf.key }}</a>
             </div>
             <v-btn
                 v-if="item.pfocr.length > limit"
                 class="my-2"
                 outlined
                 x-small
                 @click="item.showAllPfocr = !item.showAllPfocr"
             >
               {{ item.showAllPfocr ? "Show Less" : "Show More" }}
             </v-btn>
           </div>
           <span v-else>-</span>
         </template>
       </v-data-table>
     </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
import BreadCrumb from "@/components/sub/breadcrumb.vue";
import axios from "axios";
import {apiprefix} from "@/main";

export default {
  name: "Signature",
  components: { BreadCrumb },
  data() {
    return {
      results: [],
      signatureName: "",
      description: "",
      heading: "",
      mesh_url: "",
      site_number: "",
      annotation: {},
      signature_type: "",
      headers: [
        { text: "ID", value: "internal_id" },
        { text: "15mer", value: "mer15" },
        { text: "Publication", value: "publication" },
        { text: "PFOCR", value: "pfocr" },
      ],

      limit: 10,
    };
  },
  computed: {
    breadcrumbData() {
      return [
        { text: "Home", disabled: false, to: "/" },
        { text: "SignatureDB", disabled: false, to: "/signaturedb"  },
        { text: "Signature", disabled: true },
      ];
    },
    queryName() {
      return this.$route.query.name || "";
    },
    useAnnotation() {
      return ["codisease", "cogene", "cochemical"].includes(this.signature_type);
    },
    annotationLabels() {
      const maps = {
        codisease: {
          scope_note: "Mesh Note",
          // synonyms: "Disease Synonyms"
        },
        cogene: {
          other_aliases: "Gene Aliases",
          summary: "Gene Summary",
        },
        cochemical: {
          primary_target_or_process: "Primary Target / Process (GPT)",
          pharmacological_role: "Pharmacological Role (GPT)",
          pharmacological_role_description: "Pharmacological Role Description (GPT)",
          // is_pharmacologically_active: "Pharmacologically Active",
          // confidence: "Confidence",
          mesh_pharm: "MeSH Pharmacology",
          mesh_note: "MeSH Note",

        },
      };
      return maps[this.signature_type] || {};
    },
  },
  watch: {
    queryName: {
      immediate: true,
      handler(newName) {
        if (newName) this.fetchSignature(newName);
      },
    },
  },
  methods: {
    async fetchSignature(name) {
      try {
        const res = await axios.get(`${apiprefix}/api/signature/`, { params: { name } });
        const payload = res.data?.data || {};
        this.signatureName = payload.signature_name || "";
        this.description = payload.description || "";
        this.signature_type = payload.type || "";
        this.heading = payload.heading || "";
        this.mesh_url = payload.mesh_url || "";
        this.site_number = payload.site_number || "";
        this.annotation = payload.annotation || {};
        this.results = (payload.results || []).map((r) => ({
          ...r,
          showAllPmc: false,
          showAllPmid: false,
          showAllPfocr: false,
        }));
      } catch (err) {
        console.error("fetchSignature failed:", err);
      }
    },
    getVisible(arr, showAll) {
      return showAll ? arr : arr.slice(0, this.limit);
    },
  },
};
</script>
